/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AlertOutlined,
  CalendarOutlined,
  FileOutlined,
  IdcardOutlined,
  LoadingOutlined,
  MailOutlined,
  PicLeftOutlined,
  ScheduleOutlined,
  SyncOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Avatar,
  Col,
  Flex,
  Modal,
  Row,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import { useShowMaintenance } from '~/hooks/Maintenance/useShowMaintenance'
import { LoadingIndicator } from '~/pages/Contributor/ShowContributor/styles'
import { translate } from '~/utils/locale'

import { format } from 'date-fns'
import UpdateActivityTasksPlan from '../Update'
import ContactsTablePlanning from '../Contacts'

interface ITaskInfoModal {
  selectedTask: any
  isModalVisible: boolean
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>
}

const TaskInfoModal: React.FC<ITaskInfoModal> = ({
  selectedTask,
  isModalVisible,
  setIsModalVisible,
}) => {
  const { isLoading, maintenance } = useShowMaintenance()

  const { Title, Text } = Typography

  if (isLoading || !maintenance) {
    return (
      <LoadingIndicator>
        <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
      </LoadingIndicator>
    )
  }

  const getStatusInfo = (status: string | undefined) => {
    switch (status) {
      case 'received':
        return (
          <Tag color="#096dd9">
            {translate('MaintenancePlanningTableInfoModal.statusReceived')}
          </Tag>
        )
      case 'viewed':
        return (
          <Tag color="#2db7f5">
            {translate('MaintenancePlanningTableInfoModal.statusViewed')}
          </Tag>
        )
      case 'en-route':
        return (
          <Tag color="#521e9b">
            {translate('MaintenancePlanningTableInfoModal.statusEnRoute')}
          </Tag>
        )
      case 'working':
        return (
          <Tag color="#088b55">
            {translate('MaintenancePlanningTableInfoModal.statusWorking')}
          </Tag>
        )
      case 'resume-working':
        return (
          <Tag color="#088b55">
            {translate('MaintenancePlanningTableInfoModal.statusResumeWorking')}
          </Tag>
        )
      case 'break':
        return (
          <Tag color="#fa8c16">
            {translate('MaintenancePlanningTableInfoModal.statusBreak')}
          </Tag>
        )
      case 'canceled':
        return (
          <Tag color="#ce151e">
            {translate('MaintenancePlanningTableInfoModal.statusCanceled')}
          </Tag>
        )
      case 'finished':
        return (
          <Tag color="#0f4b83">
            {translate('MaintenancePlanningTableInfoModal.statusFinished')}
          </Tag>
        )
    }
  }

  return (
    <Modal
      open={isModalVisible}
      title={translate('MaintenancePlanningTableInfoModal.modalTitle')}
      onCancel={() => setIsModalVisible(false)}
      footer={null}
      width="850px"
    >
      <Tabs
        tabBarExtraContent={
          <UpdateActivityTasksPlan
            dataActivity={selectedTask?.activityDetails}
            setModalTask={setIsModalVisible}
          />
        }
      >
        <Tabs.TabPane key="tasks" tab="Tarefa">
          {selectedTask ? (
            <>
              <Row>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <IdcardOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate(
                          'MaintenancePlanningTableInfoModal.taskIdText',
                        )}
                      </Title>
                      {selectedTask?.activityDetails?.title ? (
                        <Tooltip
                          title={translate(
                            'MaintenancePlanningTableInfoModal.tooltipText',
                          )}
                        >
                          <Typography.Link
                            copyable={{ text: selectedTask.tasks[0].taskId }}
                            href={`/tarefas/visualizar/${selectedTask.tasks[0].taskId}`}
                            target="_blank"
                          >
                            {selectedTask.tasks[0].taskId.substring(0, 8)}
                          </Typography.Link>
                        </Tooltip>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <AlertOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate(
                          'MaintenancePlanningTableInfoModal.statusText',
                        )}
                      </Title>
                      {selectedTask.tasks[0].status ? (
                        getStatusInfo(selectedTask.tasks[0].status)
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>

              <Row style={{ marginTop: 14 }}>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <CalendarOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate(
                          'MaintenancePlanningTableInfoModal.taskDateText',
                        )}
                      </Title>
                      {selectedTask.tasks[0].created ? (
                        <Text style={{ fontSize: 16 }}>
                          {dayjs(selectedTask.tasks[0].created)
                            .add(3, 'hour')
                            .format('DD/MM/YYYY')}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <FileOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate(
                          'MaintenancePlanningTableInfoModal.planText',
                        )}
                      </Title>
                      {selectedTask.tasks[0].plan ? (
                        <Text style={{ fontSize: 16 }}>
                          {selectedTask.tasks[0].plan}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>
            </>
          ) : (
            ''
          )}
        </Tabs.TabPane>

        <Tabs.TabPane
          key="details"
          tab={translate('MaintenanceSystemTab.Details')}
        >
          {selectedTask?.activityDetails ? (
            <>
              <Row>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <FileOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceSystemTab.ActivityTitle')}
                      </Title>
                      {selectedTask?.activityDetails?.title ? (
                        <Text style={{ fontSize: 16 }}>
                          {selectedTask?.activityDetails?.title}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <MailOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceSystemTab.DataSource')}
                      </Title>
                      {selectedTask?.activityDetails?.data_font ? (
                        <Text style={{ fontSize: 16 }}>
                          {selectedTask?.activityDetails?.data_font}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>

              <Row style={{ marginTop: 14 }}>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <TeamOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceSystemTab.Competence')}
                      </Title>
                      {selectedTask?.activityDetails?.competence ? (
                        <Text style={{ fontSize: 16 }}>
                          {selectedTask?.activityDetails?.competence}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <UserOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceSystemTab.Responsibles')}
                      </Title>
                      {selectedTask?.activityDetails?.responsible ? (
                        <Text style={{ fontSize: 16 }}>
                          {selectedTask?.activityDetails?.responsible.name}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>

              <Row style={{ marginTop: 14 }}>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <SyncOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceSystemTab.Periodicity')}
                      </Title>
                      {selectedTask.activityDetails?.periodicity ? (
                        <>
                          {selectedTask.activityDetails.periodicity?.type ===
                          'day' ? (
                            <Text style={{ fontSize: 16 }}>
                              {translate('MaintenanceSystemTab.Text')}{' '}
                              {
                                selectedTask.activityDetails.periodicity
                                  .interval
                              }{' '}
                              {translate('MaintenanceSystemTab.Days')}
                            </Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity?.type ===
                          'sem' ? (
                            <Text style={{ fontSize: 16 }}>
                              {translate('MaintenanceSystemTab.Text')}{' '}
                              {
                                selectedTask.activityDetails.periodicity
                                  .interval
                              }{' '}
                              {translate('MaintenanceSystemTab.Weeks')}
                            </Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity?.type ===
                          'men' ? (
                            <Text style={{ fontSize: 16 }}>
                              {translate('MaintenanceSystemTab.Text')}{' '}
                              {
                                selectedTask.activityDetails.periodicity
                                  .interval
                              }{' '}
                              {translate('MaintenanceSystemTab.MonthsPlural')}
                            </Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity?.type ===
                          'anu' ? (
                            <Text style={{ fontSize: 16 }}>
                              {translate('MaintenanceSystemTab.Text')}{' '}
                              {
                                selectedTask.activityDetails.periodicity
                                  .interval
                              }{' '}
                              {translate('MaintenanceSystemTab.Years')}
                            </Text>
                          ) : (
                            ''
                          )}
                        </>
                      ) : (
                        <Text>Nenhuma informação disponível.</Text>
                      )}
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <CalendarOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceActivity.InitialDate')}
                      </Title>
                      {selectedTask.activityDetails?.initialDate
                        ? format(
                            new Date(selectedTask.activityDetails?.initialDate),
                            'dd/MM/yyyy',
                          )
                        : 'Nenhuma informação disponível.'}
                    </div>
                  </Flex>
                </Col>
              </Row>

              <Row style={{ marginTop: 14 }}>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <ScheduleOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        Dias da Semana
                      </Title>
                      {selectedTask.activityDetails?.periodicity.weekend ? (
                        <>
                          {selectedTask.activityDetails.periodicity.weekend ===
                          'everyday' ? (
                            <Text style={{ fontSize: 16 }}>Todos os dias</Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity.weekend ===
                          'days' ? (
                            <Text style={{ fontSize: 16 }}>
                              Somente durante a semana
                            </Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity.weekend ===
                          'wekeend' ? (
                            <Text style={{ fontSize: 16 }}>
                              Somente aos finais de semana
                            </Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity.weekend ===
                          'saturday' ? (
                            <Text style={{ fontSize: 16 }}>
                              Somente aos sábados
                            </Text>
                          ) : (
                            ''
                          )}

                          {selectedTask.activityDetails.periodicity.weekend ===
                          'sunday' ? (
                            <Text style={{ fontSize: 16 }}>
                              Somente aos domingos
                            </Text>
                          ) : (
                            ''
                          )}
                        </>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <PicLeftOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('MaintenanceSystemTab.Activities')}
                      </Title>
                      {selectedTask.activityDetails?.activity ? (
                        <Text style={{ fontSize: 16 }}>
                          {selectedTask.activityDetails.activity}
                        </Text>
                      ) : (
                        <Text style={{ fontSize: 16 }}>
                          Nenhuma informação disponível.
                        </Text>
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>
            </>
          ) : (
            ''
          )}
        </Tabs.TabPane>

        <Tabs.TabPane key="Contatos" tab="Contatos">
          <ContactsTablePlanning
            dataContact={selectedTask?.activityDetails?.contacts}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  )
}

export default TaskInfoModal
